/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Main script.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */

//// Image upload ////
/* Avatar */
$(document).ready(function () {
	$('#avatar_upload').attr('disabled', true);
	$('#avatar_upload_image').change(function () {
		if ($(this).val().length != 0) {
			$('#avatar_upload').attr('disabled', false);
		}
		else {
			$('#avatar_upload').attr('disabled', true);
		}
	})
});

/* Header */
$(document).ready(function () {
	$('#head_upload').attr('disabled', true);
	$('#head_upload_image').change(function () {
		if ($(this).val().length != 0) {
			$('#head_upload').attr('disabled', false);
		}
		else {
			$('#head_upload').attr('disabled', true);
		}
	})
});

//// On ready ////
$(document).ready(function () {
	//// Initialization ////

	/* Language */
	Language.init();

	/* Time */
	Time.init();

	/* Header */
	var hour = (new Date).getHours();
	if ((hour >= 6 && hour < 8) || (hour >= 17 && hour < 21))
		$('header').addClass('morning-afternoon');
	else if (hour >= 8 && hour < 17)
		$('header').addClass('day');
	else if (hour < 6 || hour >= 21)
		$('header').addClass('night');

	Header.init();

	if (App.isLogged()) {
		/* Messages */
		Messages.init();

		/* Notifications */
		Notifications.init();

        /* Mailbox */
        Mailbox.init();

		/* User menu */
		$('.dropdown-toggle').click(function () {
			$(this).parent().children('.dropdown-menu').toggle();
		});
	}

	/* Cookies */
	Language.get([
		'main.cookies_message',
		'main.cookies_dismiss',
		'main.cookies_learnMore'
	]).then(function (strings) {
		window.cookieconsent.initialise({
			content: {
				message: strings[0],
				dismiss: strings[1],
				link: strings[2],
				href: '/terms#3'
			},
			elements: {
				messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{href}}">{{link}}</a>.</span>'
			},
			position: 'bottom',
			theme: 'classic'
		});
	});

	//// Sections ////
	/* Home */
	if (App.get(1) == '' || App.get(1) == 'home') {

		/* Forum */
	} else if (App.get(1) == 'forum') {

		/* Articles */
	} else if (App.get(1) == 'articles') {

		/* Events */
	} else if (App.get(1) == 'events') {
		if (!App.get(2))
			$('.btn-home').addClass('active');
		else if (App.get(2) == 'winners')
			$('.btn-winners').addClass('active');
		else if (App.get(2) == 'help')
			$('.btn-help').addClass('active');
		/* Furni */
	} else if (App.get(1) == 'furni') {
		if (!App.get(2))
			$('.btn-home').addClass('active');
		else if (App.get(2) == 'search')
			$('.btn-search').addClass('active');
		else if (App.get(2) == 'recent')
			$('.btn-latest').addClass('active');
		else if (App.get(2) == 'edited')
			$('.btn-edited').addClass('active');
		else if (App.get(2) == 'liked')
			$('.btn-liked').addClass('active');
		else if (App.get(2) == 'help')
			$('.btn-help').addClass('active');
		/* Extras */
	} else if (App.get(1) == 'extras') {
		if (!App.get(2) || App.get(2) == 'texts')
			$('.btn-texts').addClass('active');
		else if (App.get(2) == 'characters')
			$('.btn-characters').addClass('active');
		else if (App.get(2) == 'info')
			$('.btn-info').addClass('active');
		else if (App.get(2) == 'badges')
			$('.btn-badges').addClass('active');
		else if (App.get(2) == 'ranking')
			$('.btn-ranking').addClass('active');

		/* Statistics */
	} else if (App.get(1) == 'statistics') {
		if (!App.get(2))
			$('.btn-home').addClass('active');
		else if (App.get(2) == 'community')
			$('.btn-community').addClass('active');
		else if (App.get(2) == 'messages')
			$('.btn-messages').addClass('active');
		else if (App.get(2) == 'achievements')
			$('.btn-achievements').addClass('active');

		/* Account */
	} else if (App.get(1) == 'account') {
		if (!App.get(2))
			$('.btn-account').addClass('active');
		else if (App.get(2) == 'security')
			$('.btn-security').addClass('active');
		else if (App.get(2) == 'privacy')
			$('.btn-privacy').addClass('active');
		else if (App.get(2) == 'profile')
			$('.btn-profile').addClass('active');
		else if (App.get(2) == 'incidences')
			$('.btn-incidences').addClass('active');
		else if (App.get(2) == 'support')
			$('.btn-support').addClass('active');

		/* Messages */
	} else if (App.get(1) == 'messages') {

		Messages.open(true, App.get(2));
	}

	/* Lightboxes and tooltips */
	$(function () {
		$('.lightbox-img').lightBox();
	});

	/** Headlines **/
	var totHeight = 150 * ($('#headlines .headline').length / 3);
	$('#headlines').height(totHeight);
	var current = 1;
	var end = totHeight / 150;

	function advance() {
		if (current == end) {
			$('#headlines').stop().animate({marginTop: '0px'}, 450);
			current = 1;
		} else {
			$('#headlines').stop().animate({marginTop: -(150 * current) + 'px'}, 450);
			current++;
		}
	}

	var itvl = setInterval(function () {
		advance()
	}, 10000);

	/* Notice messages */
	// When message is clicked, hide it
	$('.notice').click(function () {
		$(this).addClass('hide');
	});
});

/* Drag */
(function ($) {
	$.fn.drags = function (opt) {
		opt = $.extend({
			handle: "",
			cursor: "",
			draggableClass: "draggable",
			activeHandleClass: "active-handle"
		}, opt);

		var $selected = null;
		var $elements = (opt.handle === "") ? this : this.find(opt.handle);

		return $elements.css('cursor', opt.cursor).on("mousedown", function (e) {
			if (opt.handle === "") {
				$selected = $(this);
				$selected.addClass(opt.draggableClass);
			} else {
				$selected = $(this).parent();
				$selected.addClass(opt.draggableClass).find(opt.handle).addClass(opt.activeHandleClass);
			}
			var drg_h = $selected.outerHeight(),
				drg_w = $selected.outerWidth(),
				pos_y = $selected.offset().top + drg_h - e.pageY,
				pos_x = $selected.offset().left + drg_w - e.pageX;
			$(document).on("mousemove", function (e) {
				$selected.offset({
					top: e.pageY + pos_y - drg_h,
					left: e.pageX + pos_x - drg_w
				});
			}).on("mouseup", function () {
				$(this).off("mousemove");
				$selected.removeClass(opt.draggableClass);
				$selected = null;
			});
			e.preventDefault();
		}).on("mouseup", function () {
			if (opt.handle === "") {
				$selected.removeClass(opt.draggableClass);
			} else {
				$selected.removeClass(opt.draggableClass)
					.find(opt.handle).removeClass(opt.activeHandleClass);
			}
			$selected = null;
		});

	}
})(jQuery);
$(function () {
	$('.draggable').drags();
});

/* BBCode */
function addTag(id, tag, close) {
	var text = document.getElementById(id),
		openTag = '[' + tag + ']',
		closeTag = close === false ? '' : '[/' + tag + ']';
	if (document.selection) {
		text.focus();
		var sel = document.selection.createRange();
		sel.text = openTag + sel.text + closeTag;
	} else if (text.selectionStart || text.selectionStart == '0') {
		var beforeTag = (text.value).substring(0, text.selectionStart);
		if (closeTag) {
			var beforeFocus = beforeTag + openTag + (text.value).substring(text.selectionStart, text.selectionEnd);
			text.value = beforeFocus + closeTag + (text.value).substring(text.selectionEnd, text.textLength);
			setCaretPosition(text, beforeFocus.length);
		} else {
			text.value = beforeTag + openTag + (text.value).substring(text.selectionStart, text.textLength);
			setCaretPosition(text, (beforeTag.length + openTag.length));
		}
	} else {
		text.value = openTag + closeTag;
		setCaretPosition(text, (openTag.length + closeTag.length));
	}
}

function addSmiley(id, tag) {
	var text = document.getElementById(id);
	if (document.selection) {
		text.focus();
		sel = document.selection.createRange();
		sel.text = tag;
	} else if (text.selectionStart || text.selectionStart == '0') {
		var beforeTag = (text.value).substring(0, text.selectionStart);
		text.value = beforeTag + tag + (text.value).substring(text.selectionEnd, text.textLength);
		setCaretPosition(text, (beforeTag.length + tag.length));
	} else {
		text.value = tag;
		setCaretPosition(text, tag.length);
	}
}

function setCaretPosition(elem, caretPos) {
	if (elem != null) {
		if (elem.createTextRange) {
			var range = elem.createTextRange();
			range.move('character', caretPos);
			range.select();
		} else {
			if (elem.selectionStart) {
				elem.focus();
				elem.setSelectionRange(caretPos, caretPos);
			} else
				elem.focus();
		}
	}
}

/** JS equivalent to PHP. **/
function number_format(number, decimals, dec_point, thousands_sep) {
	//  discuss at: http://phpjs.org/functions/number_format/
	// original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// improved by: davook
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Theriault
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// bugfixed by: Michael White (http://getsprink.com)
	// bugfixed by: Benjamin Lupton
	// bugfixed by: Allan Jensen (http://www.winternet.no)
	// bugfixed by: Howard Yeend
	// bugfixed by: Diogo Resende
	// bugfixed by: Rival
	// bugfixed by: Brett Zamir (http://brett-zamir.me)
	//  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	//  revised by: Luke Smith (http://lucassmith.name)
	//    input by: Kheang Hok Chin (http://www.distantia.ca/)
	//    input by: Jay Klehr
	//    input by: Amir Habibi (http://www.residence-mixte.com/)
	//    input by: Amirouche
	//   example 1: number_format(1234.56);
	//   returns 1: '1,235'
	//   example 2: number_format(1234.56, 2, ',', ' ');
	//   returns 2: '1 234,56'
	//   example 3: number_format(1234.5678, 2, '.', '');
	//   returns 3: '1234.57'
	//   example 4: number_format(67, 2, ',', '.');
	//   returns 4: '67,00'
	//   example 5: number_format(1000);
	//   returns 5: '1,000'
	//   example 6: number_format(67.311, 2);
	//   returns 6: '67.31'
	//   example 7: number_format(1000.55, 1);
	//   returns 7: '1,000.6'
	//   example 8: number_format(67000, 5, ',', '.');
	//   returns 8: '67.000,00000'
	//   example 9: number_format(0.9, 0);
	//   returns 9: '1'
	//  example 10: number_format('1.20', 2);
	//  returns 10: '1.20'
	//  example 11: number_format('1.20', 4);
	//  returns 11: '1.2000'
	//  example 12: number_format('1.2000', 3);
	//  returns 12: '1.200'
	//  example 13: number_format('1 000,50', 2, '.', ' ');
	//  returns 13: '100 050.00'
	//  example 14: number_format(1e-8, 8, '.', '');
	//  returns 14: '0.00000001'

	number = (number + '')
		.replace(/[^0-9+\-Ee.]/g, '');
	var n = !isFinite(+number) ? 0 : +number,
		prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
		sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
		dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
		s = '',
		toFixedFix = function (n, prec) {
			var k = Math.pow(10, prec);
			return '' + (Math.round(n * k) / k)
					.toFixed(prec);
		};
	// Fix for IE parseFloat(0.55).toFixed(0) = 0;
	s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
		.split('.');
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || '')
			.length < prec) {
		s[1] = s[1] || '';
		s[1] += new Array(prec - s[1].length + 1)
			.join('0');
	}
	return s.join(dec);
}

/**
 * Tooltip.
 *
 * @copyright http://osvaldas.info
 */
$(function () {
	var targets = $('[rel~=tooltip]'),
		target = false,
		tooltip = false,
		title = false;

	targets.bind('mouseenter', function () {
		target = $(this);
		title = target.data('name');
		description = target.data('description');
		tooltip = $('<div id="tooltip"></div>');

		if (description == 'furni.price') {
			var price = $.parseJSON(target.children().html());
			if (price.goldbars == 0) {
				if (price.credits == 0)
					description = '-';
				else
					description = price.credits + ' <img src="/images/furni_credits.png" />';
			} else {
				if (price.credits == 0)
					description = price.goldbars + ' <img src="/images/furni_goldbars.png" />';
				else
					description = price.goldbars + ' <img src="/images/furni_goldbars.png" /> + ' + price.credits + ' <img src="/images/furni_credits.png" />';
			}
		}

		title_html = '';
		description_html = '';
		if (title!==undefined) {
		    title_html = '<div class="title">' + title + '</div>';
        }
		if (description!==undefined) {
		    description_html = '<div class="description">' + description + '</div>';
        }

		tooltip.css('opacity', 0).html(title_html+''+description_html+'').appendTo('body');

		var init_tooltip = function () {
			if ($(window).width() < tooltip.outerWidth() * 1.5)
				tooltip.css('max-width', $(window).width() / 2);
			else
				tooltip.css('max-width', 340);

			var pos_left = target.offset().left + ( target.outerWidth() / 2 ) - ( tooltip.outerWidth() / 2 ),
				pos_top = target.offset().top - tooltip.outerHeight() - 20;

			if (pos_left < 0) {
				pos_left = target.offset().left + target.outerWidth() / 2 - 20;
				tooltip.addClass('left');
			}
			else
				tooltip.removeClass('left');

			if (pos_left + tooltip.outerWidth() > $(window).width()) {
				pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20;
				tooltip.addClass('right');
			}
			else
				tooltip.removeClass('right');

			if (pos_top < 0) {
				var pos_top = target.offset().top + target.outerHeight();
				tooltip.addClass('top');
			}
			else
				tooltip.removeClass('top');

			tooltip.css({left: pos_left, top: pos_top})
				.animate({top: '+=10', opacity: 1}, 50);
		};

		init_tooltip();
		$(window).resize(init_tooltip);

		var remove_tooltip = function () {
			tooltip.animate({top: '-=10', opacity: 0}, 50, function () {
				$(this).remove();
			});
		};

		target.bind('mouseleave', remove_tooltip);
		tooltip.bind('click', remove_tooltip);
	});
});

/**
 * jQuery lightBox plugin
 * This jQuery plugin was inspired and based on Lightbox 2 by Lokesh Dhakar (http://www.huddletogether.com/projects/lightbox2/)
 * and adapted to me for use like a plugin from jQuery.
 * @name jquery-lightbox-0.5.js
 * @author Leandro Vieira Pinho - http://leandrovieira.com
 * @version 0.5
 * @date April 11, 2008
 * @category jQuery plugin
 * @copyright (c) 2008 Leandro Vieira Pinho (leandrovieira.com)
 * @license CCAttribution-ShareAlike 2.5 Brazil - http://creativecommons.org/licenses/by-sa/2.5/br/deed.en_US
 * @example Visit http://leandrovieira.com/projects/jquery/lightbox/ for more informations about this jQuery plugin
 */
(function ($) {
	$.fn.lightBox = function (settings) {
		settings = jQuery.extend({
			overlayBgColor: '#000',
			overlayOpacity: 0.8,
			fixedNavigation: false,
			imageLoading: '/images/loading.gif',
			containerBorderSize: 10,
			containerResizeSpeed: 400,
			txtImage: 'Imagen',
			txtOf: 'de',
			keyToClose: 'c',
			keyToPrev: 'p',
			keyToNext: 'n',
			imageArray: [],
			activeImage: 0
		}, settings);
		var jQueryMatchedObj = this;

		function _initialize() {
			_start(this, jQueryMatchedObj);
			return false;
		}

		function _start(objClicked, jQueryMatchedObj) {
			$('embed, object, select').css({'visibility': 'hidden'});
			_set_interface();
			settings.imageArray.length = 0;
			settings.activeImage = 0;
			if (jQueryMatchedObj.length == 1) {
				settings.imageArray.push(new Array(objClicked.getAttribute('href'), objClicked.getAttribute('title')));
			} else {
				for (var i = 0; i < jQueryMatchedObj.length; i++) {
					settings.imageArray.push(new Array(jQueryMatchedObj[i].getAttribute('href'), jQueryMatchedObj[i].getAttribute('title')));
				}
			}
			while (settings.imageArray[settings.activeImage][0] != objClicked.getAttribute('href')) {
				settings.activeImage++;
			}
			_set_image_to_view();
		}

		function _set_interface() {
			$('body').append('<div id="jquery-overlay"></div><div id="jquery-lightbox"><div id="lightbox-container-image-box"><div id="lightbox-container-image"><img id="lightbox-image"><div style="" id="lightbox-nav"><a href="#" id="lightbox-nav-btnPrev"></a><a href="#" id="lightbox-nav-btnNext"></a></div><div id="lightbox-loading"><a href="#" id="lightbox-loading-link"><img src="' + settings.imageLoading + '"></a></div></div></div></div>');
			var arrPageSizes = ___getPageSize();
			$('#jquery-overlay').css({
				backgroundColor: settings.overlayBgColor,
				opacity: settings.overlayOpacity,
				width: arrPageSizes[0],
				height: arrPageSizes[1]
			}).fadeIn();
			var arrPageScroll = ___getPageScroll();
			$('#jquery-lightbox').css({top: arrPageScroll[1] + (arrPageSizes[3] / 10), left: arrPageScroll[0]}).show();
			$('#jquery-overlay,#jquery-lightbox').click(function () {
				_finish();
			});
			$('#lightbox-loading-link,#lightbox-secNav-btnClose').click(function () {
				_finish();
				return false;
			});
			$(window).resize(function () {
				var arrPageSizes = ___getPageSize();
				$('#jquery-overlay').css({width: arrPageSizes[0], height: arrPageSizes[1]});
				var arrPageScroll = ___getPageScroll();
				$('#jquery-lightbox').css({top: arrPageScroll[1] + (arrPageSizes[3] / 10), left: arrPageScroll[0]});
			});
		}

		function _set_image_to_view() {
			$('#lightbox-loading').show();
			if (settings.fixedNavigation) {
				$('#lightbox-image,#lightbox-container-image-data-box,#lightbox-image-details-currentNumber').hide();
			} else {
				$('#lightbox-image,#lightbox-nav,#lightbox-nav-btnPrev,#lightbox-nav-btnNext,#lightbox-container-image-data-box,#lightbox-image-details-currentNumber').hide();
			}
			var objImagePreloader = new Image();
			objImagePreloader.onload = function () {
				$('#lightbox-image').attr('src', settings.imageArray[settings.activeImage][0]);
				_resize_container_image_box(objImagePreloader.width, objImagePreloader.height);
				objImagePreloader.onload = function () {
				};
			};
			objImagePreloader.src = settings.imageArray[settings.activeImage][0];
		};
		function _resize_container_image_box(intImageWidth, intImageHeight) {
			var intCurrentWidth = $('#lightbox-container-image-box').width();
			var intCurrentHeight = $('#lightbox-container-image-box').height();
			var intWidth = (intImageWidth + (settings.containerBorderSize * 2));
			var intHeight = (intImageHeight + (settings.containerBorderSize * 2));
			var intDiffW = intCurrentWidth - intWidth;
			var intDiffH = intCurrentHeight - intHeight;
			$('#lightbox-container-image-box').animate({
				width: intWidth,
				height: intHeight
			}, settings.containerResizeSpeed, function () {
				_show_image();
			});
			if ((intDiffW == 0) && (intDiffH == 0)) {
				if ($.browser.msie) {
					___pause(250);
				} else {
					___pause(100);
				}
			}
			$('#lightbox-container-image-data-box').css({width: intImageWidth});
			$('#lightbox-nav-btnPrev,#lightbox-nav-btnNext').css({height: intImageHeight + (settings.containerBorderSize * 2)});
		};
		function _show_image() {
			$('#lightbox-loading').hide();
			$('#lightbox-image').fadeIn(function () {
				_show_image_data();
				_set_navigation();
			});
			_preload_neighbor_images();
		};
		function _show_image_data() {
			$('#lightbox-container-image-data-box').slideDown('fast');
			$('#lightbox-image-details-caption').hide();
			if (settings.imageArray[settings.activeImage][1]) {
				$('#lightbox-image-details-caption').html(settings.imageArray[settings.activeImage][1]).show();
			}
			if (settings.imageArray.length > 1) {
				$('#lightbox-image-details-currentNumber').html(settings.txtImage + ' ' + (settings.activeImage + 1) + ' ' + settings.txtOf + ' ' + settings.imageArray.length).show();
			}
		}

		function _set_navigation() {
			$('#lightbox-nav').show();
			$('#lightbox-nav-btnPrev,#lightbox-nav-btnNext').css({'background': 'transparent url() no-repeat'});
			if (settings.activeImage != 0) {
				if (settings.fixedNavigation) {
					$('#lightbox-nav-btnPrev').css({'background': 'url() left 15% no-repeat'}).unbind().bind('click', function () {
						settings.activeImage = settings.activeImage - 1;
						_set_image_to_view();
						return false;
					});
				} else {
					$('#lightbox-nav-btnPrev').unbind().hover(function () {
						$(this).css({'background': 'url() left 15% no-repeat'});
					}, function () {
						$(this).css({'background': 'transparent url() no-repeat'});
					}).show().bind('click', function () {
						settings.activeImage = settings.activeImage - 1;
						_set_image_to_view();
						return false;
					});
				}
			}
			if (settings.activeImage != (settings.imageArray.length - 1)) {
				if (settings.fixedNavigation) {
					$('#lightbox-nav-btnNext').css({'background': 'url() right 15% no-repeat'}).unbind().bind('click', function () {
						settings.activeImage = settings.activeImage + 1;
						_set_image_to_view();
						return false;
					});
				} else {
					$('#lightbox-nav-btnNext').unbind().hover(function () {
						$(this).css({'background': 'url() right 15% no-repeat'});
					}, function () {
						$(this).css({'background': 'transparent url() no-repeat'});
					}).show().bind('click', function () {
						settings.activeImage = settings.activeImage + 1;
						_set_image_to_view();
						return false;
					});
				}
			}
			_enable_keyboard_navigation();
		}

		function _enable_keyboard_navigation() {
			$(document).keydown(function (objEvent) {
				_keyboard_action(objEvent);
			});
		}

		function _disable_keyboard_navigation() {
			$(document).unbind();
		}

		function _keyboard_action(objEvent) {
			if (objEvent == null) {
				keycode = event.keyCode;
				escapeKey = 27;
			} else {
				keycode = objEvent.keyCode;
				escapeKey = objEvent.DOM_VK_ESCAPE;
			}
			key = String.fromCharCode(keycode).toLowerCase();
			if ((key == settings.keyToClose) || (key == 'x') || (keycode == escapeKey)) {
				_finish();
			}
			if ((key == settings.keyToPrev) || (keycode == 37)) {
				if (settings.activeImage != 0) {
					settings.activeImage = settings.activeImage - 1;
					_set_image_to_view();
					_disable_keyboard_navigation();
				}
			}
			if ((key == settings.keyToNext) || (keycode == 39)) {
				if (settings.activeImage != (settings.imageArray.length - 1)) {
					settings.activeImage = settings.activeImage + 1;
					_set_image_to_view();
					_disable_keyboard_navigation();
				}
			}
		}

		function _preload_neighbor_images() {
			if ((settings.imageArray.length - 1) > settings.activeImage) {
				objNext = new Image();
				objNext.src = settings.imageArray[settings.activeImage + 1][0];
			}
			if (settings.activeImage > 0) {
				objPrev = new Image();
				objPrev.src = settings.imageArray[settings.activeImage - 1][0];
			}
		}

		function _finish() {
			$('#jquery-lightbox').remove();
			$('#jquery-overlay').fadeOut(function () {
				$('#jquery-overlay').remove();
			});
			$('embed, object, select').css({'visibility': 'visible'});
		}

		function ___getPageSize() {
			var xScroll, yScroll;
			if (window.innerHeight && window.scrollMaxY) {
				xScroll = window.innerWidth + window.scrollMaxX;
				yScroll = window.innerHeight + window.scrollMaxY;
			} else if (document.body.scrollHeight > document.body.offsetHeight) {
				xScroll = document.body.scrollWidth;
				yScroll = document.body.scrollHeight;
			} else {
				xScroll = document.body.offsetWidth;
				yScroll = document.body.offsetHeight;
			}
			var windowWidth, windowHeight;
			if (self.innerHeight) {
				if (document.documentElement.clientWidth) {
					windowWidth = document.documentElement.clientWidth;
				} else {
					windowWidth = self.innerWidth;
				}
				windowHeight = self.innerHeight;
			} else if (document.documentElement && document.documentElement.clientHeight) {
				windowWidth = document.documentElement.clientWidth;
				windowHeight = document.documentElement.clientHeight;
			} else if (document.body) {
				windowWidth = document.body.clientWidth;
				windowHeight = document.body.clientHeight;
			}
			if (yScroll < windowHeight) {
				pageHeight = windowHeight;
			} else {
				pageHeight = yScroll;
			}
			if (xScroll < windowWidth) {
				pageWidth = xScroll;
			} else {
				pageWidth = windowWidth;
			}
			arrayPageSize = new Array(pageWidth, pageHeight, windowWidth, windowHeight);
			return arrayPageSize;
		};
		function ___getPageScroll() {
			var xScroll, yScroll;
			if (self.pageYOffset) {
				yScroll = self.pageYOffset;
				xScroll = self.pageXOffset;
			} else if (document.documentElement && document.documentElement.scrollTop) {
				yScroll = document.documentElement.scrollTop;
				xScroll = document.documentElement.scrollLeft;
			} else if (document.body) {
				yScroll = document.body.scrollTop;
				xScroll = document.body.scrollLeft;
			}
			arrayPageScroll = new Array(xScroll, yScroll);
			return arrayPageScroll;
		};
		function ___pause(ms) {
			var date = new Date();
			curDate = null;
			do {
				var curDate = new Date();
			}
			while (curDate - date < ms);
		};
		return this.unbind('click').click(_initialize);
	};
})(jQuery);
